import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.css'],
})
export class ShareModalComponent implements OnInit{
  videoLink: string;
  socialPlatforms = [
    { name: 'Facebook', icon: './assets/social-media/facebook.svg', appUrl: 'fb://facewebmodal/f?href=', webUrl: 'https://www.facebook.com/sharer/sharer.php?u=' },
    { name: 'Twitter', icon: './assets/social-media/x.svg', appUrl: 'twitter://post?url=', webUrl: 'https://twitter.com/intent/tweet?url=' },
    { name: 'WhatsApp', icon: './assets/social-media/whatsapp.svg', appUrl: 'whatsapp://send?text=', webUrl: 'https://web.whatsapp.com/send?text=' },
    { name: 'LinkedIn', icon: './assets/social-media/linkedin.svg', appUrl: 'linkedin://shareArticle?url=', webUrl: 'https://www.linkedin.com/sharing/share-offsite/?url=' },
    { name: 'Email', icon: './assets/social-media/email.svg', appUrl: 'mailto:?body=', webUrl: '' },
  ];  

  constructor(
    public dialogRef: MatDialogRef<ShareModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toastrService: CustomControlsService
  ) {
    this.videoLink = data.videoLink;
  }

  ngOnInit(): void {
    
  }

  copyLink() {
    navigator.clipboard.writeText(this.videoLink).then(() => {
      // alert('Link copied to clipboard!');
      this.showSuccess('Link copied to clipboard!');
    });
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  shareOnPlatform(platform: any) {
    const url = `${platform.url}${encodeURIComponent(this.videoLink)}`;
    window.open(url, '_blank');
  }

  navigateToApp(platform: any) {
    const utmLink = this.videoLink + (this.videoLink.includes('?') ? '&' : '?') +
      'utm_source=share&utm_medium=' + platform.name.toLowerCase();
    const videoLink = encodeURIComponent(utmLink);
    const appUrl = platform.appUrl ? `${platform.appUrl}${videoLink}` : null;
    const webUrl = platform.webUrl ? `${platform.webUrl}${videoLink}` : null;
    if (appUrl) {
      const timeout = setTimeout(() => {
        if (webUrl) {
          window.open(webUrl, '_blank');
        } else {
          alert(`No fallback web URL available for ${platform.name}`);
        }
      }, 1500); 
      window.location.href = appUrl;
      setTimeout(() => clearTimeout(timeout), 2000);
    } else if (webUrl) {
      window.open(webUrl, '_blank');
    } else {
      alert(`No URL configured for ${platform.name}`);
    }
  }
}
